module.exports = __webpack_public_path__ + "img/icon_culture.88af9049.png";